// extracted by mini-css-extract-plugin
export default {"cls1":"BankLookupDialog-Dialog_cls1__HtHBZ","cls2":"BankLookupDialog-Dialog_cls2__Ur-KM BankLookupDialog-Dialog_cls1__HtHBZ"};